import React from 'react';
//
import history from 'lib/history';
import routes from 'router/routes';
import Layout from 'components/layout';
import PageContainer from 'components/page-container';
import Button from 'components/buttons/simple';
import labels from 'constants/labels';

const OopsPage = () => {
  function handleBack() {
    history.push(routes.dashboard);
  }

  return (
    <Layout>
      <PageContainer>
        <h2>{labels.titles.pages.oops}</h2>
        <p>We couldn't find the page you were looking for</p>
        <br />
        <Button onClick={handleBack}>Back</Button>
      </PageContainer>
    </Layout>
  );
};

export default OopsPage;
